import React from 'react';
import { getScreenName } from '../../../Utils/helper';
import { PopupInput, QuestionLabel } from '../HealthPlan/styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function DuedateInputField(props) {
  const {
    element,
    inputFieldErrorHandler,
    index,
    fromPdp,
    showNewUI,
    inAppForm,
  } = props;
  const fireInputEvent = (event) => {
    if (!inAppForm)
      fireEvent({
        category: 'entered_mobile',
        screen_name: getScreenName(),
        sku_type: fromPdp ? 'pdp' : 'clinic',
        page_url: typeof window != 'undefined' ? window.location.href : 'NA',
        parent: 'booking_confirmation_popup',
        support_variable: event?.target.value,
      });
  };
  return (
    <>
      <QuestionLabel showNewUI={showNewUI} for="start">
        {element?.question_text}
      </QuestionLabel>

      <PopupInput
        type="date"
        id="start"
        name="duedate"
        onChange={(event) => {
          inputFieldErrorHandler(event.target.value, index);
        }}
        onBlur={(event) => {
          fireInputEvent(event);
        }}
        required={element?.required == 1 ? true : false}
      />
    </>
  );
}
